import './styles.sass';

import React from 'react';
import { truncate } from 'lodash-es';

import dayjs from 'util/date';
import PropTypes from 'prop-types';
import TimeAgo from 'react-timeago';

import OutputsList from 'components/Explorer/OutputsList';

const TITLE_LENGTH = 70; // Characters
const VISIBLE_OUTPUTS_COUNT = 2;

class NewsHighlight extends React.Component {
  state = {
    visible: false
  };

  static propTypes = {
    highlight: PropTypes.object
  };

  toggleOutputsVisibility = () => {
    this.setState({ visible: !this.state.visible });
  };

  toggleOutputsVisibilityButtonText = (outputsCount) => {
    if (this.state.visible) {
      return I18n.t('Explorer.Highlights.LatestMentions.show_fewer');
    } else {
      return I18n.t('Explorer.Highlights.LatestMentions.cites_more', {
        count: Math.max(outputsCount - VISIBLE_OUTPUTS_COUNT, 0)
      });
    }
  };

  render() {
    const title = truncate(this.props.highlight.title, {
      length: TITLE_LENGTH,
      separator: /\W/
    });
    const date = dayjs(this.props.highlight.posted_at).utc().format('D MMM YYYY');
    const outputsCount = this.props.highlight.outputs.length;

    return (
      <div key={`${this.props.highlight.id}-highlight`} className="NewsHighlight">
        <div className="NewsHighlight-logo">
          <img src={this.props.highlight.source.logo} alt={this.props.highlight.source.title} />
        </div>
        <a className="NewsHighlight-link" href={this.props.highlight.url} target="_blank" rel="noreferrer">
          Mentioned <TimeAgo date={dayjs(date).format('YYYY-MM-DD h:mm A UTC')} /> by{' '}
          {this.props.highlight.source.title}
        </a>
        <div className="NewsHighlight-title">{title}</div>
        <div className="NewsHighlight-cites">
          <strong>
            {I18n.t('Explorer.Highlights.NewsHighlights.cites', {
              count: outputsCount
            })}
          </strong>
          {outputsCount > VISIBLE_OUTPUTS_COUNT && (
            <button onClick={this.toggleOutputsVisibility} className="NewsHighlight-toggle">
              {this.toggleOutputsVisibilityButtonText(outputsCount)}
            </button>
          )}
          :
          <OutputsList
            post={this.props.highlight}
            outputs={this.props.highlight.outputs}
            visible={this.state.visible}
            visibleOutputsCount={VISIBLE_OUTPUTS_COUNT}
          />
        </div>
      </div>
    );
  }
}

export default NewsHighlight;
